module.exports = __webpack_public_path__ + "static/2-4b7489e15b44c88e52756ff27ea5e7ff.jpg";